import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

export const checkBatchParticipationCompletion = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "batches/checkBatchParticipationCompletion",
  async (batchId: string, { extra: { adminRepository } }) => {
    return adminRepository!.checkBatchParticipationCompletion(batchId);
  },
);

export const resetCheckBatchParticipationCompletion = createAction("batches/resetCheckBatchParticipationCompletion");
